import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import Swal from 'sweetalert2'
import { fullName } from '@modules/form-wizard/utils'
import toastr from '@modules/toastr'
import moment from 'moment'


export default class CemeteryPlot extends React.Component {
  resource = '/cemetery_plots'
  form_key = 'cemetery_plot'
  defaults = {}

  // Delete lines as needed
  fee = async r => {
    if (r.payment_amount) return r.payment_amount
  
    switch (r.request_type) {
      case 'new':
        return 68.20
      case 're-open':
        return 40
      case 'replacement deed':
        return 68.20
      default:
        return 68.20
    }
  }
//   free = true
//   postpaid = true
  skip_location = true
  hide_buttons = {
    status: true,
    deny: true,
  }
  custom_actions = [
    {
      text: 'Forward To Sr. Officer',
      icon: 'user-tie',
      roles: [['officer']],
      test: r => ['pending'].includes(r.application_decision) && r.request_type != 're-open',
      fn: async (record) => this.recommendToSeniorOfficer(record)
    },
    {
      text: 'Forward To Sr. Officer',
      icon: 'user-tie',
      roles: [['inspector']],
      test: r => ['officer viewed'].includes(r.application_decision) && r.request_type == 're-open',
      fn: async (record) => this.recommendToSeniorOfficer(record, 'inspector')
    },
    recommendToInspector.call(this),
    recommendToPS.call(this),
    finalPSApproval.call(this),
  ]

  validate = null

  foremost = null

  columns = () => [
    {
      name: 'Request Type',
      selector: row => row.request_type.capitalize(),
    },
  ]

  fields = form => [
     '::Type of Request',
     {
          name: "request_type",
          label: "Application Purpose",
          options: [{label: "Application for new Cemetery Plot", value: 'new'},
                    {label: "Request for Permission to Re-Open Plot", value: 're-open'},
                    {label: "Application for Replacement Deed", value: 'replacement deed'}]
     },

     '::Deceased Information',
     {
          name: "deceased_first_name",
          label: "First Name",
     },
     {
          name: "deceased_middle_name",
          label: "Middle Name",
          required: false,
     },
     {
          name: "deceased_last_name",
          label: "Last Name",
     },
     {
          name: "deceased_dob",
          label: "Date of Birth",
          type: "date",
          showYearDropdown: true
     },
     {
          name: "time_of_burial",
          label: form.request_type == 'replacement deed' ? 'Date/Time of Burial was' : 'Date/Time of Burial',
          type: "date",
          showYearDropdown: true,
          showTimeSelect: true,
          timeFormat: "hh:mm aa",
          timeIntervals: 15,
          dateFormat: "MMMM d, yyyy h:mm aa",
          view: { 
            value: (v) => {
              const dt = moment(v)
              return dt.format('MMMM Do YYYY, h:mm A')
            }
          }
     },
     {
          name: "funeral_home",
          label: "Name of Funeral Home",
     },

     '::Deeder Information',
     {
          name: 'i_am_deeder',
          label: 'Are you the Deeder?',
          type: 'select:bool',
     },
     {
          name: "deeder_first_name",
          label: "First Name",
          hide: form.i_am_deeder,
     },
     {
          name: "deeder_middle_name",
          label: "Middle Name",
          required: false,
          hide: form.i_am_deeder,
     },
     {
          name: "deeder_last_name",
          label: "Last Name",
          hide: form.i_am_deeder,
     },
     {
          name: 'deeder_relationship',
          label: 'Relationship to Deceased',
          options: ['Spouse', 'Parent', 'Son', 'Daughter', 'Relative', 'Other'],
     },
     {
          name: "deeder_phone",
          label: "Phone #",
          type: "phone"
     },
     {
          name: "deeder_email",
          label: "Email",
          type: "email"
     },
     {
          name: "deeder_address",
          label: "Address",
     },
     {
          name: "deeder_po_box",
          label: "P.O. Box",
     },

     '::Cemetery Plot Information',
     {
          name: "cemetery",
          label: "Name of Cemetery",
     },
     {
          name: "number_of_plots",
          label: form.request_type == 'replacement deed' ? 'No. of Plot(s) was' : 'No. of Plot(s)',
          type: "integer",
          hide: form.request_type == 're-open',
     },
     {
          name: 'last_purchased',
          label: 'Last Purchased',
          type: 'date',
          showYearDropdown: true,
          hide: form.request_type != 're-open',
     },
     {
          name: "section",
          label: "Section",
     },
     {
          name: "plot_number",
          label: "Plot Number",
          type: "integer",
     },
     {
          name: "additional_comments",
          type: "textarea",
          required: false,
     },
     {
          name: 'plot_condition',
          hide: true,
          view: true
     },

     /*{
          name: "date_of_purchase",
          type: "date",
          showYearDropdown: true
     },
     {
          name: "receipt_number",
          label: "Receipt NO.",
          type: "text",
     },
     {
          name: "signature_of_deeder",
          type: "text",
     },
     {
          name: "processed_by",
          type: "text",
     },
     {
          name: "signature_of_officer",
          type: "text",
     },
     {
          name: "supervisor_review",
          label: "Reviewed by Supervisor",
          type: "text",
     },
     {
          name: "date_of_review",
          label: "Date",
          type: "date",
          showYearDropdown: true
     }, */

     "::Document Requirements",
     {
          name: "deceased_photo_upload",
          label: "Photo ID of Deceased",
          type: "file:all",
          key: "image.0", 
          hint: "Passport, National Insurance Card or Driver's License"   
     },
     {
          name: "deeder_photo_upload",
          label: "Photo ID of Deeder",
          type: "file:all",
          key: "image.1",  
          hint: "Passport, National Insurance Card or Driver's License"   

     },
     {
          name: "death_cert_upload",
          label: "Death Certificate or Proof of Death",
          type: "file:all",
          key: "image.2",
     },
     {
          name: 'plot_deed_or_auth_upload',
          label: 'Plot Deed or Authorization Letter from Dependents',
          type: 'file:all',
          key: 'image.3',
          hide: form.request_type != 're-open',
     },
     {
          name: 'interred_obituary_or_article_upload',
          label: 'Interred Obituary or Newspaper Article',
          type: 'file:all',
          key: 'image.4',
          hide: form.request_type != 're-open',
     },
  ]

  async recommendToSeniorOfficer (record, role = 'officer') {
    const { props, resource, form_key } = this
    const { history, location } = props

    console.log(role)

    const inputOptions = role == 'inspector' ? {
      'approved': "Cemetery Plot able to be re-opened",
      'denied': "New Cemetery Plot needs to be purchased",
    } : {
      'approved': "I recommend this applicant",
      'denied': "I do not recommend this applicant",
    }

    const { value, isDismissed } = await Swal.fire({
      icon: 'question',
      title: 'Forward To Sr. Officer',
      html: `
        What is your recommendation to the Sr. Officer
        regarding the applicant,
        <strong>${fullName(record.user, 'initial')}</strong>?
      `,
      input: 'select',
      inputOptions: inputOptions,
      showCancelButton: true,
      confirmButtonText: 'Send',
    })

    if (isDismissed) return

    try {
      await $app.axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: value,
        },
      })

      if (location?.state?.view) {
        const view = { ...location.state.view }

        history.replace(location.pathname, {
          ...location.state,
          view,
        })
      }

      toastr.success('Success', 'Application successfully updated')
    } catch (error) {
      console.error(error)
      Swal.fire(
        'Oops...',
        'There has been an error with processing your application',
        'error'
      )
    }
  }

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}

function recommendToInspector () {
  return {
    text: 'Forward To Inspector',
    icon: 'user-tie',
    roles: ['officer'],
    test: r => r.application_decision == 'pending' && r.request_type == 're-open',
    fn: async record => {
      const { props, resource, form_key } = this
      const { history, location } = props

      const { value, isDismissed } = await Swal.fire({
        icon: 'question',
        title: 'Forward To Inspector',
        html: `
          What is your recommendation to the Inspector
          regarding the applicant,
          <strong>${fullName(record.user, 'initial')}</strong>?
        `,
        input: 'select',
        inputOptions: {
          'approved': "I recommend this applicant",
          'denied': "I do not recommend this applicant",
        },
        showCancelButton: true,
        confirmButtonText: 'Send',
      })

      if (isDismissed) return

      try {
        await $app.axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: value,
          },
        })

        if (location?.state?.view) {
          const view = { ...location.state.view }

          history.replace(location.pathname, {
            ...location.state,
            view,
          })
        }

        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      }
    }
  }
}

function recommendToPS () {
  return {
    text: 'Forward To Permanent Secretary',
    icon: 'user-tie',
    roles: ['senior_officer'],
    test: r => ['officer viewed', 'inspector viewed'].includes(r.application_decision),
    fn: async record => {
      const { props, resource, form_key } = this
      const { history, location } = props

      const { value, isDismissed } = await Swal.fire({
        icon: 'question',
        title: 'Forward To Permanent Secretary',
        html: `
          What is your recommendation to the Permanent Secretary 
          regarding the applicant,
          <strong>${fullName(record.user, 'initial')}</strong>?
        `,
        input: 'select',
        inputOptions: {
          'approved': "I recommend this applicant",
          'denied': "I do not recommend this applicant",
        },
        showCancelButton: true,
        confirmButtonText: 'Send',
      })

      if (isDismissed) return

      try {
        await $app.axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: value,
          },
        })

        if (location?.state?.view) {
          const view = { ...location.state.view }

          history.replace(location.pathname, {
            ...location.state,
            view,
          })
        }

        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      }
    }
  }
}

function finalPSApproval () {
  return {
    text: 'Approve Application',
    icon: 'user-tie',
    roles: ['permanent_secretary'],
    test: r => ['senior officer viewed'].includes(r.application_decision),
    fn: async record => {
      const { props, resource, form_key } = this
      const { history, location } = props

      const { value, isDismissed } = await Swal.fire({
        icon: 'question',
        title: 'Approve Application',
        html: `
          What is your final decision regarding the applicant,
          <strong>${fullName(record.user, 'initial')}</strong>?
        `,
        input: 'select',
        inputOptions: {
          'approved': "I approve this applicant",
          'denied': "I do not approve this applicant",
        },
        showCancelButton: true,
        confirmButtonText: 'Send',
      })

      if (isDismissed) return

      try {
        await $app.axios.put(resource + '/update_application', {
          [form_key]: {
            form_num: record.form_num,
            application_decision: value,
          },
        })

        if (location?.state?.view) {
          const view = { ...location.state.view }

          history.replace(location.pathname, {
            ...location.state,
            view,
          })
        }

        toastr.success('Success', 'Application successfully updated')
      } catch (error) {
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      }
    }
  }
}